module.exports = __webpack_public_path__ + "static/mess-3505e16c2864bcdfa6c8a206f23fe193.jpg";